import { useState } from "react";
import { Scan, RefreshCw } from "lucide-react";

// Faithful mode: how closely the finished mesh matches the maker's own render. A number, never a pass/fail —
// a low match offers a Redo but nothing is ever blocked.
export const FidelityCard = ({ fidelity, onRedo, busy }) => {
  const [open, setOpen] = useState(false);
  if (!fidelity || typeof fidelity.match_pct !== "number") return null;
  const low = !!fidelity.below_threshold;
  const biggest = (fidelity.mismatch || [])[0];

  return (
    <div
      data-testid="fidelity-card"
      data-low={low ? "1" : "0"}
      className={`rounded-2xl border px-4 py-3 ${low ? "border-amber-500/50 bg-amber-500/10" : "border-accent/50 bg-accent/10"}`}
    >
      <div className="flex items-center gap-2">
        <Scan className={`h-5 w-5 shrink-0 ${low ? "text-amber-500" : "text-accent"}`} />
        <span className="text-sm font-bold" data-testid="fidelity-score">
          Matches your render: {fidelity.match_pct}%
        </span>
        <button
          type="button"
          data-testid="fidelity-overlay-toggle"
          onClick={() => setOpen((v) => !v)}
          className="ml-auto text-xs font-semibold text-muted-foreground underline underline-offset-2 hover:text-foreground"
        >
          {open ? "Hide overlay" : "Show overlay"}
        </button>
      </div>
      <p className="mt-1.5 text-xs text-muted-foreground" data-testid="fidelity-note">
        {low
          ? `The sculpt drifted from your render${biggest ? ` — biggest difference ${biggest.kind === "missing" ? "missing at the" : "added at the"} ${biggest.where}` : ""}. You can print it as it is, or redo the sculpt.`
          : "Silhouettes compared from the front" +
            (Object.keys(fidelity.views || {}).length ? ` and ${Object.keys(fidelity.views).join(", ")}` : "") +
            " — your design came through."}
      </p>
      {open && fidelity.overlay && (
        <div className="mt-3">
          <img data-testid="fidelity-overlay" src={fidelity.overlay} alt="render vs mesh silhouette overlay" className="w-full max-w-[260px] rounded-xl border border-border bg-white" />
          <p className="mt-1 text-[11px] text-muted-foreground">Blue = only in your render · orange = only in the mesh · grey = both</p>
        </div>
      )}
      {low && onRedo && (
        <button
          type="button"
          data-testid="fidelity-redo-btn"
          disabled={!!busy}
          onClick={onRedo}
          className="mt-3 inline-flex items-center gap-2 rounded-full border border-border px-4 py-2 text-xs font-bold transition-colors hover:bg-muted disabled:opacity-50"
        >
          <RefreshCw className="h-3.5 w-3.5" /> Redo the sculpt
        </button>
      )}
    </div>
  );
};
